import { trackUser, trackVirtualPageView } from '../utils/tracking';

export default function track({ from, to }) {
    // Add GA4 tracking for each page view when users do not hard reload the page
    const isHardReload = Boolean(!from.name);
    if (!isHardReload) {
        trackVirtualPageView({ pageUrl: to.path, pageTitle: document.title });
    }
    trackUser();
}
